import {
	Account,
	ACCOUNT_USER_ROLE,
	Dataset,
	DatasetGroupsAccess,
	Map,
	MapGroupsAccess,
	User,
} from "~auth/types/__generated/gql/graphql";

export const isAccountOwner = (
	accountLikeObj?: Pick<Account, "_currentUserRole">,
) => {
	return (
		!!accountLikeObj &&
		accountLikeObj._currentUserRole === ACCOUNT_USER_ROLE.OWNER
	);
};

export const isMapCreator = (
	mapLikeObj?: Pick<Map, "userId">,
	userLikeObj?: Pick<User, "id">,
) => {
	return !!mapLikeObj && !!userLikeObj && mapLikeObj.userId === userLikeObj.id;
};

export const isDatasetCreator = (
	datasetLikeObj?: Pick<Dataset, "userId">,
	userLikeObj?: Pick<User, "id">,
) => {
	return (
		!!datasetLikeObj &&
		!!userLikeObj &&
		datasetLikeObj.userId === userLikeObj.id
	);
};

export const ACCOUNT_ROLES_HIERACHY: `${ACCOUNT_USER_ROLE}`[] = [
	ACCOUNT_USER_ROLE.VIEWER,
	ACCOUNT_USER_ROLE.EDITOR,
	ACCOUNT_USER_ROLE.ADMIN,
	ACCOUNT_USER_ROLE.OWNER,
] as const;

export const hasEqualOrHigherAccessThanSpecifiedRole = (
	accountLikeObj?: Pick<Account, "_currentUserRole">,
	role?: `${ACCOUNT_USER_ROLE}`,
) => {
	return (
		!!accountLikeObj?._currentUserRole &&
		!!role &&
		ACCOUNT_ROLES_HIERACHY.indexOf(accountLikeObj._currentUserRole) >=
			ACCOUNT_ROLES_HIERACHY.indexOf(role)
	);
};

export const isInGroupWithEditAccess = (
	groupsAccessLikeList: { id: string; viewable: boolean; editable: boolean }[],
	userGroupMemberLikeList: { userGroupId: string }[],
) => {
	if (!groupsAccessLikeList.length || !userGroupMemberLikeList.length)
		return false;

	const objGroupAccessesByGroupId = groupsAccessLikeList.reduce(
		(pre, cur) => ({
			...pre,
			[cur.id]: cur,
		}),
		{} as Record<string, (MapGroupsAccess | DatasetGroupsAccess)[][number]>,
	);

	return userGroupMemberLikeList.some(
		(membership) =>
			!!objGroupAccessesByGroupId[membership.userGroupId]?.editable,
	);
};

export const isInGroupWithViewAccess = (
	groupsAccessLikeList: { id: string; viewable: boolean; editable: boolean }[],
	userGroupMemberLikeList: { userGroupId: string }[],
) => {
	if (!groupsAccessLikeList.length || !userGroupMemberLikeList.length)
		return false;

	const objGroupAccessesByGroupId = groupsAccessLikeList.reduce(
		(pre, cur) => ({
			...pre,
			[cur.id]: cur,
		}),
		{} as Record<string, (MapGroupsAccess | DatasetGroupsAccess)[][number]>,
	);

	return userGroupMemberLikeList.some(
		(membership) =>
			!!objGroupAccessesByGroupId[membership.userGroupId]?.viewable ||
			!!objGroupAccessesByGroupId[membership.userGroupId]?.editable,
	);
};
